export default __webpack_public_path__ + "static/media/excel-graph.8b50d00b.png";